var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPennylane(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    "data-name": "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "29.23mm",
    height: "29.23mm",
    viewBox: "0 0 83 83",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.42,82.85C18.58,82.85,0,64.26,0,41.42S18.58,0,41.42,0s41.42,18.58,41.42,41.42-18.58,41.42-41.42,41.42ZM41.42,8c-18.43,0-33.42,14.99-33.42,33.42s14.99,33.42,33.42,33.42,33.42-14.99,33.42-33.42S59.85,8,41.42,8Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M33.61,41.42c0-5.78,3.15-10.82,7.81-13.52-2.3-1.33-4.96-2.11-7.81-2.11-8.63,0-15.63,7-15.63,15.63s7,15.63,15.63,15.63c2.85,0,5.51-.78,7.81-2.11-4.67-2.7-7.81-7.74-7.81-13.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.24,25.79c-2.85,0-5.51.78-7.81,2.11,4.67,2.7,7.81,7.74,7.81,13.52s-3.15,10.82-7.81,13.52c2.3,1.33,4.96,2.11,7.81,2.11,8.63,0,15.63-7,15.63-15.63s-7-15.63-15.63-15.63Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPennylane);
export default __webpack_public_path__ + "static/media/pennylane.6bc3494635410bc317ba334ca3218add.svg";
export { ForwardRef as ReactComponent };